export var SDK_VERSION = '6.16.0';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/core/esm/version.js
// module id = 616
// module chunks = 1